import { useEffect, useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { AuthLayout } from "../../components/AuthLayout";
import { useAuth } from "../../lib/auth";
import { api } from "../../lib/api";
import { ErrorMessage } from "../../components/ErrorMessage";

// status: "verifying" | "ok" | "error"
export function VerifyEmail() {
  const [params] = useSearchParams();
  const token = params.get("token") || "";
  const { isAuthenticated } = useAuth();

  const [status, setStatus] = useState(token ? "verifying" : "error");

  useEffect(() => {
    if (!token) return;
    let cancelled = false;
    api
      .verifyEmail(token)
      .then(() => {
        if (!cancelled) setStatus("ok");
      })
      .catch(() => {
        if (!cancelled) setStatus("error");
      });
    return () => {
      cancelled = true;
    };
  }, [token]);

  const continueTo = isAuthenticated ? "/" : "/login";
  const continueLabel = isAuthenticated ? "Go to X·RING" : "Sign in";

  return (
    <AuthLayout title="Email verification">
      {status === "verifying" && (
        <div className="auth-msg" role="status">
          Verifying your email…
        </div>
      )}

      {status === "ok" && (
        <>
          <div className="auth-msg" role="status">
            Your email is verified. You're all set.
          </div>
          <Link to={continueTo} className="btn primary auth-submit">
            {continueLabel}
          </Link>
        </>
      )}

      {status === "error" && (
        <>
          <ErrorMessage message="This verification link is invalid or has expired." />
          <Link to={continueTo} className="btn auth-submit">
            {continueLabel}
          </Link>
        </>
      )}
    </AuthLayout>
  );
}
